import { SetStateAction } from "react";
import { MRT_RowSelectionState } from "material-react-table";
import { AssignedCateringMenu } from "../../../../../Domain/Types/FloorPlan/CateringMenuAssignment.type";

/** handle the initial catering item selection in the table  */
export const handleInitialCateringServiceSelect = (
  assigned: AssignedCateringMenu[],
  setRowSelection: (value: SetStateAction<MRT_RowSelectionState>) => void
) => {
  const usedMenu = assigned.map(as => as.cateringMenuId);
  if (!usedMenu.length) return;

  for (const menu of usedMenu) {
    setRowSelection(prev => ({ ...prev, [`${menu}`]: true }));
  }
};
